// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2lCki","label":"LabeledBox_label__2GYqg"};